import type { IAdViewLink } from "@finn-no/adview-provider-frontend-types";
import { Trans } from "@lingui/react";
import { Icon } from "../Icon.tsx";
import { ScreenReaderSeparator } from "../ScreenReaderSeparator.tsx";

type Props = {
  links?: IAdViewLink[];
  title?: string;
};

export const EvFaqLinks = ({ links, title }: Props) => {
  if (!links?.length) {
    return null;
  }

  return (
    <div className="my-4">
      <h3 className="t4 mt-0 mb-12">
        {title || (
          <Trans
            id="itemPageLayout.ev.faqLinks.title"
            message="Frequently asked questions"
            comment="Heading above the article links at the bottom of the cards in the EV info section"
          />
        )}
      </h3>

      <div className="flex flex-col gap-8">
        {links.map(({ uri, title }) => (
          <a
            key={uri}
            href={uri}
            target="_blank"
            rel="noopener nofollow"
            className="w-fit flex items-center gap-4"
            onClick={() => {
              // TODO: MBJ-324 track FAQ link click
            }}
          >
            {title}
            <ScreenReaderSeparator />
            <Icon name="LinkExternal" className="inline-block align-baseline" />
          </a>
        ))}
      </div>
    </div>
  );
};
